import { useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";
import {
  headerSubtitle,
  headerTitle,
  holder,
} from "../../i18n/securities/preconfirmationStep";

const PreconfirmationHeader = () => {
  const { language, currentHolder } = useAppSelector(
    (state: RootState) => state.securities
  );
  return (
    <div>
      <h1>
        {headerTitle[language]} -{" "}
        <b>
          {holder[language]} {currentHolder}
        </b>
      </h1>
      <p>{headerSubtitle[language]}</p>
    </div>
  );
};

export default PreconfirmationHeader;
